<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>
<!--      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte precios de tratamiento</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_04</div>
        </b-col>
      </b-row>-->

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de precios especiales
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">

            <b-col cols="4">
              <validation-provider name="tratamiento" :rules="{ required: false }" v-slot="validationContext">
                <label>Tratamiento:</label>
                <v-select style="width: 100%" :clearable="false" :options="listaTratamientos"
                          v-model="filtro.tratamiento"
                          :reduce="(variable) => variable.idTratamiento"
                          label="nombre" placeholder="Selecciona un tratamiento" multiple>
                  <span slot="no-options">No hay tratamientos disponibles</span>
                </v-select>
                <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
              </validation-provider>
            </b-col>

            <b-col cols="4">
              <validation-provider name="especialidad" :rules="{ required: false }" v-slot="validationContext">
                <label>Especialidad:</label>
                <v-select style="width: 100%" :clearable="false" :options="listaEspecialidades"
                          v-model="filtro.especialidad"
                          :reduce="(variable) => variable.id"
                          label="especialidad" placeholder="Selecciona una especialidad" multiple>
                  <span slot="no-options">No hay tratamientos disponibles</span>
                </v-select>
                <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
              </validation-provider>
            </b-col>


            <b-col>
              <download-excel
                  v-if="datosTabla.length > 0"
                  :data="datosTabla"
                  class="btn btn-primary"
                  :fields="fieldsExcel"

                  worksheet="My Worksheet"
                  name="reportePreciosTratamientos.xls"
              >
                Generar Excel
              </download-excel>
            </b-col>


            <b-col align="right">
              <b-button v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                        @click="generar()" :disabled="loader">Generar
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>


      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>

export default {
  components: {

  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      datosTabla: [],
      fields: [],
      paginaActual: 1,
      loader: false,
      filtro: {
        especialidad: null
      },
      listaTratamientos: null,
      listaEspecialidades: null,
      excel: [],
      fieldsExcel: {
        "Tratamiento": "tratamiento",
        "Especialidad": "especialidad",
        "Clinica": "clinica",
        "Zona": "zona",
        "Precio": "precio",

      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerTratamientos();
    this.obtenerEspecialidades();
  },
  methods: {
    obtenerTratamientos() {
      this.$http
          .get(this.$api + "catalogos/obtenerTratamientos")
          .then((response) => {
            if (response.data.data) {
              this.listaTratamientos = response.data.data;
            }
          });
    },
    obtenerEspecialidades() {
      this.$http
          .get(this.$api + "catalogos/obtenerEspecialidadesOrigen")
          .then((response) => {
            if (response.data.data) {
              this.listaEspecialidades = response.data.data;
            }
          });
    },
    generar() {
      this.loader = true;
      this.datosTabla = [];

      this.$http.post(this.$api + 'reportes/preciosTratamientoClinica', this.filtro).then(respuesta => {
        if (respuesta.data.data.reporteTratamientoEspecialidadDTOS) {
          this.fields.push({key: "tratamiento", label: "Tratamiento", sortable: true});
          this.fields.push({key: "especialidad", label: "Especialidad", sortable: true});
          this.fields.push({key: "zona", label: "Zona", sortable: true});
          this.fields.push({key: "clinica", label: "Clinica", sortable: true});
          this.fields.push({key: "precio", label: "Precio", sortable: true});

          this.datosTabla = respuesta.data.data.reporteTratamientoEspecialidadDTOS

        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 1;
      })
    }
  }
}
</script>

<style scoped>

</style>
